import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../Button/Button';
import Icon from '../Icon/Icon';
import Modal from '../Modal';
import styles from './ConfirmApprovalsCommentModal.module.scss';

const ConfirmApprovalsCommentModal = ({ isShow, onClose, approvalType, approvalTypes, approveVideo, declineVideo, revokeVideo }) => {
  const { t } = useTranslation();

  const handleConfirm = () => {
    if (approvalType === approvalTypes.approve) {
      approveVideo();
    }

    if (approvalType === approvalTypes.decline) {
      declineVideo();
    }

    if (approvalType === approvalTypes.revoke) {
      revokeVideo();
    }

    onClose();
  };

  return (
    <Modal className={styles.modal} open={isShow} onClose={onClose}>
      <div className={styles.container}>
        <div className={styles.modalHeader}>
          {approvalType === approvalTypes.approve && (
            <span className={styles.modalTitle}>{t('approvals.comment.confirm_modal.title_approve')}</span>
          )}
          {approvalType === approvalTypes.decline && (
            <span className={styles.modalTitle}>{t('approvals.comment.confirm_modal.title_decline')}</span>
          )}
          {approvalType === approvalTypes.revoke && (
            <span className={styles.modalTitle}>{t('approvals.comment.confirm_modal.title_revoke')}</span>
          )}
          <Icon src="close" className={styles.closeIcon} onClick={onClose} />
        </div>
        <div className={styles.text}>
          {approvalType === approvalTypes.approve && <span>{t('approvals.comment.confirm_modal.text_approve')}</span>}
          {approvalType === approvalTypes.decline && <span>{t('approvals.comment.confirm_modal.text_decline')}</span>}
          {approvalType === approvalTypes.revoke && <span>{t('approvals.comment.confirm_modal.text_revoke')}</span>}
        </div>
        <div className={styles.buttonsContainer}>
          <CustomButton variant="secondary" label={t('general.back')} onClick={onClose} />
          <CustomButton className={styles.removeBtn} variant="primary" label={t('general.continue')} onClick={handleConfirm} />
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmApprovalsCommentModal;
